// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendPsCustomersMutationVariables = Types.Exact<{
  sendPsCustomersRequestDTO: Types.InputMaybe<Types.SendPsCustomersRequestDtoInput>;
}>;


export type SendPsCustomersMutationResult = { __typename?: 'Mutation', sendPsCustomers: boolean };

export const SendPsCustomersGql = gql`
    mutation SendPsCustomers($sendPsCustomersRequestDTO: SendPsCustomersRequestDTOInput) {
  sendPsCustomers(sendPsCustomersRequestDTO: $sendPsCustomersRequestDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendPsCustomersInjectable extends Apollo.Mutation<SendPsCustomersMutationResult, SendPsCustomersMutationVariables> {
    override document = SendPsCustomersGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */